import { ChangeEvent, Dispatch, SetStateAction } from "react";

import { ButtonGroup, Form, ToggleButton } from "react-bootstrap";
import DatePicker from "react-datepicker";

import {
  ReferentialDwellingCategory,
  ReferentialType,
} from "../../../_constants/referentialType";
import { RequiredInput } from "../../../common/components/FormError";
import SelectCreatable from "../../../common/components/SelectCreatable";
import { IReferentials } from "../../referential/reducers";
import { IDwelling } from "../reducers";

export interface DwellingFormFeatureProps {
  dwelling: IDwelling;
  setDwelling: Dispatch<SetStateAction<IDwelling>>;
  referentials: IReferentials;
}

const DwellingFeatureForm = ({
  dwelling,
  setDwelling,
  referentials,
}: DwellingFormFeatureProps) => {
  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.currentTarget;
    updateDwelling(name, value);
  };
  const updateDwelling = (dwellingField: string, value: any) => {
    setDwelling({
      ...dwelling,
      [dwellingField]: value,
    });
  };

  return (
    <>
      <div className="d-flex flex-column flex-md-row flex-wrap gap-3">
        <div className="d-flex flex-column align-items-end justify-content-end me-md-4">
          <label className="add-prop-label mb-0">
            <RequiredInput />
          </label>
          <ButtonGroup
            className="d-flex flex-row flex-nowrap"
            style={{ minWidth: "270px" }}
          >
            <ToggleButton
              id="radio-individual"
              className="switch-dwelling-prop switch-dwell-left"
              checked={dwelling.isSociety}
              type="radio"
              value="true"
              onClick={() => updateDwelling("isSociety", true)}
            >
              Société
            </ToggleButton>
            <ToggleButton
              id="radio-society"
              className="switch-dwelling-prop switch-dwell-right"
              checked={!dwelling.isSociety}
              type="radio"
              value="false"
              onClick={() => updateDwelling("isSociety", false)}
            >
              Particulier
            </ToggleButton>
          </ButtonGroup>
        </div>
        <div className="d-flex flex-column">
          <label className="add-prop-label ms-2">
            {dwelling.isSociety ? "Nom de société : " : "Nom du bailleur : "}
            <RequiredInput />
          </label>
          <input
            className="add-prop-input"
            type="text"
            name="lessorName"
            defaultValue={dwelling.lessorName}
            onChange={handleChange}
          />
        </div>
        {!dwelling.isSociety && (
          <div className="d-flex flex-column">
            <label className="add-prop-label ms-2">Prénom du bailleur :</label>
            <input
              className="add-prop-input"
              type="text"
              name="lessorFirstname"
              defaultValue={dwelling.lessorFirstname}
              onChange={handleChange}
            />
          </div>
        )}
        <div className="d-flex flex-column">
          <label className="w-100 add-prop-label ms-2">N° lot :</label>
          <input
            className="w-100 add-prop-input"
            type="text"
            name="managementLotNumber"
            defaultValue={dwelling.managementLotNumber}
            onChange={handleChange}
          />
        </div>
        <div className="d-flex flex-column">
          <label className="w-100 add-prop-label ms-2">
            N° fiscal du local :
          </label>
          <input
            className="w-100 add-prop-input"
            type="text"
            name="taxNumber"
            defaultValue={dwelling.taxNumber}
            onChange={handleChange}
          />
        </div>
        <div className="d-flex flex-column">
          <label className="w-100 add-prop-label ms-2">N° Ademe (DPE) :</label>
          <input
            className="w-100 add-prop-input"
            type="text"
            name="ademeNumber"
            defaultValue={dwelling.ademeNumber}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row flex-wrap gap-4 mt-3">
        {dwelling.category &&
          dwelling.category.value !== ReferentialDwellingCategory.GARAGE && (
            <div className="d-flex flex-column mt-3 mt-md-0 me-md-3">
              <label className="add-prop-label">
                Type de location : <RequiredInput />
              </label>
              <ButtonGroup
                className="d-flex flex-row flex-nowrap"
                style={{ minWidth: "270px" }}
              >
                <ToggleButton
                  id="radio-none-furnished"
                  className="switch-dwelling-prop ms-1 switch-dwell-left"
                  checked={!dwelling.isFurnished}
                  type="radio"
                  value="false"
                  onClick={() => updateDwelling("isFurnished", false)}
                  style={{ minWidth: "130px" }}
                >
                  Nue
                </ToggleButton>
                <ToggleButton
                  id="radio-furnished"
                  className="switch-dwelling-prop ms-1 switch-dwell-right"
                  checked={dwelling.isFurnished}
                  type="radio"
                  value="true"
                  onClick={() => updateDwelling("isFurnished", true)}
                  style={{ minWidth: "130px" }}
                >
                  Meublée
                </ToggleButton>
              </ButtonGroup>
            </div>
          )}
        <div className="d-flex flex-column" style={{ minWidth: "160px" }}>
          <label className="add-prop-label">
            Catégorie de bien : <RequiredInput />
          </label>
          <SelectCreatable
            className="d-flex select-creatable"
            options={referentials[ReferentialType.DWELLING_CATEGORY].data}
            getValue={(value) => updateDwelling("category", value)}
            isMulti={false}
            creatable={true}
            defaultValue={dwelling.category}
          />
        </div>
        {dwelling.category &&
          [
            ReferentialDwellingCategory.APARTMENT,
            ReferentialDwellingCategory.HOUSE,
          ].includes(dwelling.category.value) && (
            <div className="d-flex flex-column" style={{ minWidth: "110px" }}>
              <label className="add-prop-label">
                Type de bien : <RequiredInput />
              </label>
              <SelectCreatable
                className="d-flex select-creatable"
                options={referentials[ReferentialType.DWELLING_TYPE].data}
                getValue={(value) => updateDwelling("type", value)}
                isMulti={false}
                creatable={true}
                defaultValue={dwelling.type}
              />
            </div>
          )}

        {dwelling.category &&
          [ReferentialDwellingCategory.PREMISE].includes(
            dwelling.category.value
          ) && (
            <div className="d-flex flex-column">
              <label className="w-100 add-prop-label ms-2">
                Type de bien : <RequiredInput />
              </label>
              <div className="select-creatable-team-member-form">
                <SelectCreatable
                  options={
                    referentials[ReferentialType.DWELLING_TYPE_PROMISE].data
                  }
                  getValue={(value) => updateDwelling("type", value)}
                  isMulti={false}
                  creatable={true}
                  defaultValue={dwelling.type}
                />
              </div>
            </div>
          )}
        <div className="d-flex flex-column" style={{ maxWidth: "85px" }}>
          <label className="add-prop-label ms-2">Surface :</label>
          <input
            className="add-prop-input"
            type="text"
            name="area"
            placeholder="m²"
            defaultValue={dwelling.area}
            onChange={handleChange}
          />
        </div>
      </div>
      {/* {dwelling.isFurnished && (
        <>
          <div className="d-flex flex-wrap gap-3 align-items-end mt-3">
            <div className="d-flex">
              <label className="add-prop-label mb-0">Inventaire déjà réalisé par la plateforme ?</label>
              <Form.Check
                type="switch"
                className="radio-order ms-2"
              // name='inventory'
              // checked={dwelling.isInventory || false}
              // onChange={() => updateDwelling('isInventory', !dwelling.isInventory)}
              />
            </div>
            <div className="d-flex flex-wrap gap-3">
              <div className="d-flex">
                <Form.Select
                  className="text-muted"
                // name='type'
                // defaultValue={dwelling.type}
                // onChange={handleChange}
                >
                  {Object.entries(DwellingInventoryType).map(([key, value]) => {
                    return (
                      <option key={key} value={value}>
                        {DwellingInventoryTypeLabel[value]}
                      </option>
                    );
                  })}
                </Form.Select>
              </div>
              <div className="d-flex">
                <Button
                  className="d-flex align-items-center"
                  variant="success"
                  style={{ padding: '6px 20px' }}
                // onClick={linkBuilding}
                >
                  <span className="m-0 me-2" style={{ fontSize: '40px', lineHeight: '18px' }}>
                    +
                  </span>
                  Créer mon inventaire
                </Button>
              </div>
            </div>
          </div>
        </>
      )} */}
      <div className="d-flex flex-wrap gap-3 mt-3">
        <div className="d-flex flex-column">
          <label className="add-prop-label ms-2">
            Période de construction : <RequiredInput />
          </label>
          <div className="d-lg-flex">
            <SelectCreatable
              className={"d-flex align-items-end select-creatable me-2"}
              options={
                referentials[ReferentialType.DWELLING_CONSTRUCTION_PERIOD].data
              }
              getValue={(value) => updateDwelling("constructionPeriod", value)}
              isMulti={false}
              creatable={true}
              defaultValue={dwelling.constructionPeriod}
            />
            <DatePicker
              className="add-prop-input date-select ms-2 mt-2 mt-lg-0"
              dateFormat="dd/MM/yyyy"
              placeholderText="Date exacte"
              selected={
                dwelling.constructionDate
                  ? new Date(dwelling.constructionDate)
                  : undefined
              }
              locale="fr"
              onChange={(date) => updateDwelling("constructionDate", date)}
            />
          </div>
        </div>
        <div className="d-flex flex-wrap gap-3 align-items-end">
          <div className="d-flex flex-wrap gap-2 align-items-center mb-1">
            <span className="ms-2 mb-0 add-prop-label">
              S’agit-il d’une copropriété ?{" "}
            </span>
            <Form.Check
              type="switch"
              className="radio-order"
              checked={dwelling.isCondominium || false}
              onChange={() =>
                updateDwelling("isCondominium", !dwelling.isCondominium)
              }
            />
          </div>
          {dwelling.isCondominium !== false &&
            dwelling.isCondominium !== undefined && (
              <>
                <div className="d-flex flex-column">
                  <label className="w-100 add-prop-label ms-2">
                    Syndicat de copropriété :
                  </label>
                  <input
                    className="add-prop-input"
                    type="text"
                    name="condominiumAssociation"
                    defaultValue={dwelling.condominiumAssociation}
                    onChange={handleChange}
                  />
                </div>
                <div
                  className="d-flex flex-column"
                  style={{ maxWidth: "150px" }}
                >
                  <label className="w-100 add-prop-label ms-2">
                    N° lot de copropriété :
                  </label>
                  <input
                    className="add-prop-input"
                    type="text"
                    name="condominiumNumber"
                    defaultValue={dwelling.condominiumNumber}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
        </div>
      </div>
      {/* NE PAS SUPPRIMER */}
      {/*<div>*/}
      {/*  <div className="d-flex flex-column">*/}
      {/*    <label className="w-100 add-prop-label ms-2">&nbsp;</label>*/}
      {/*    <div className="d-flex flex-row justify-content-start">*/}
      {/*      */}
      {/*      {Object.entries(ConstructionPeriod).map(([key, value]) => {*/}
      {/*        return (*/}
      {/*          <ToggleButton*/}
      {/*            className="btn-add-prop ms-1"*/}
      {/*            type="radio"*/}
      {/*            key={key}*/}
      {/*            checked={dwelling.constructionPeriod === value}*/}
      {/*            name={value}*/}
      {/*            value={value}*/}
      {/*            onClick={() => updateDwelling('constructionPeriod', value)}*/}
      {/*          >*/}
      {/*            {ConstructionPeriodLabel[value]}*/}
      {/*          </ToggleButton>*/}
      {/*        );*/}
      {/*      })}*/}
      {/*      <div className="w-100 d-flex flex-row">*/}
      {/*        <p className="add-prop-label mt-1 ms-2 flex-nowrap">S’agit-il d’une copropriété ?</p>*/}
      {/*        <Form.Check*/}
      {/*          type="switch"*/}
      {/*          className=" ms-2"*/}
      {/*          name="isCondominium"*/}
      {/*          checked={dwelling.isCondominium}*/}
      {/*          onChange={() => updateDwelling('isCondominium', !dwelling.isCondominium)}*/}
      {/*        />*/}
      {/*      </div>*/}
      {/*      <div className="d-flex flex-column mt-lg-0">*/}
      {/*        <label className="w-100 add-prop-label ms-2">N° lot de copropriété :</label>*/}
      {/*        <input*/}
      {/*          className="add-prop-input"*/}
      {/*          type="text"*/}
      {/*          name="condominiumNumber"*/}
      {/*          defaultValue={dwelling.condominiumNumber}*/}
      {/*          onChange={handleChange}*/}
      {/*        />*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<Row className="d-none d-md-block">*/}
      {/*    <Col md={5}>*/}
      {/*        <div className="d-flex mt-3">*/}
      {/*            <i className="bi bi-info-circle-fill d-block me-2" style={{color: "#666"}}></i>*/}
      {/*            <p className="p-no-period">*/}
      {/*                Vous ne connaissez pas la période de construction ? Consultez le&nbsp;*/}
      {/*                <a target="blank" href="https://www.registre-coproprietes.gouv.fr/annuaire">*/}
      {/*                    registre de copropriété*/}
      {/*                </a>*/}
      {/*            </p>*/}
      {/*        </div>*/}
      {/*    </Col>*/}
      {/*</Row>*/}
    </>
  );
};
export default DwellingFeatureForm;
